var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalGuidance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{stroke:#b135ad;}.c,.d{stroke:none;}.d{fill:#b135ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8146 -3150)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8189 3003)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(43 147)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 10 19.5 C 4.761680126190186 19.5 0.5 15.23832035064697 0.5 10 C 0.5 4.761680126190186 4.761680126190186 0.5 10 0.5 C 15.23832035064697 0.5 19.5 4.761680126190186 19.5 10 C 19.5 15.23832035064697 15.23832035064697 19.5 10 19.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.252 150.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,11.621V1H6.379L9.2,3.512v8.109ZM2.367,9.507H7.834V8.631H2.367Zm0-1.83H7.834V6.8H2.367Zm0-1.83H5.311V4.97H2.367Z",
    transform: "translate(-0.459 -0.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.553,11.151ZM.5.5V11.2H8.783V3.034L5.934.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-8139 3160)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H5.7V1H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4.76837158203125e-07 0 L 5.695800304412842 0 L 5.695800304412842 1 L 4.76837158203125e-07 1 L 4.76837158203125e-07 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-8139 3158)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H2.689V1H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 2.384185791015625e-06 0 L 2.688962459564209 0 L 2.688962459564209 1 L 2.384185791015625e-06 1 L 2.384185791015625e-06 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-8139 3162)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H5.7V1H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4.76837158203125e-07 0 L 5.695800304412842 0 L 5.695800304412842 1 L 4.76837158203125e-07 1 L 4.76837158203125e-07 0 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalGuidance);
export default __webpack_public_path__ + "static/media/additional-guidance.638650dd5da789359794d5a83bf5b11c.svg";
export { ForwardRef as ReactComponent };